import React from 'react';
export var SwitchSize = /*#__PURE__*/ function(SwitchSize) {
    SwitchSize["sm"] = "sm";
    SwitchSize["md"] = "md";
    return SwitchSize;
}({});
export var SwitchVariants = /*#__PURE__*/ function(SwitchVariants) {
    SwitchVariants["primary"] = "primary";
    SwitchVariants["error"] = "error";
    return SwitchVariants;
}({});
